import React from "react";
import "./about.css";
import ME from "../../assets/VikiBig.jpeg";
import { FaAward } from "react-icons/fa";
import { FiUsers } from "react-icons/fi";
import { VscFolderLibrary } from "react-icons/vsc";

const About = () => {
  return (
    <section id="about">
      <h5>Conoceme</h5>
      <h2>Acerca de Mi</h2>

      <div className="container about__container">
        <div className="about__me">
          <div className="about__me-image">
            <img src={ME} alt="About Image" />
          </div>
        </div>

        <div className="about__content">
          <div className="about__cards">
            <article className="about__card">
              <FaAward className="about__icon" />
              <h5>Experiencia</h5>
              <small>+7 Años en la Industria</small>
            </article>
            <article className="about__card">
              <FiUsers className="about__icon" />
              <h5>Clientes</h5>
              <small>+49 en todo el Mundo</small>
            </article>
            <article className="about__card">
              <VscFolderLibrary className="about__icon" />
              <h5>Proyectos</h5>
              <small>3 Proyectos Completados</small>
            </article>
          </div>

          <p>
            Si en el día de su casamiento quieren verse hermosas y sentirse
            cómodas con su look nupcial, entonces <i>Victoria MakeUp </i>será
            una gran alternativa. Este equipo de profesionales les brindará una
            atención personalizada y a la medida de sus necesidades. Sin duda,
            se trata de una buena opción para las novias que residen o vienen a
            festejar su boda en la provincia de Mendoza.
          </p>
          <a href="#contact" className="btn btn-primary">
            ¡Contactame!
          </a>
        </div>
      </div>
    </section>
  );
};

export default About;
